module.exports = __webpack_public_path__ + "static/media/capitalsphere_interview.12ec6c34.svg";